// app/frontend/entrypoints/application.jsx
import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import ReactRootController from "../controllers/react_root_controller.jsx";
import ReactIslandController from "../controllers/react_island_controller.jsx";
import ReactCarouselController from "../controllers/react_carousel_controller.jsx";
import ReactCountdownController from "../controllers/react_countdown_controller.jsx";
import ReactMinimalController from "../controllers/react_minimal_controller.jsx";
import ReactGenericController from "../controllers/react_generic_controller.jsx";

const app = Application.start();
app.register("react-root", ReactRootController);
app.register("react-island", ReactIslandController);
app.register("react-carousel", ReactCarouselController);
app.register("react-countdown", ReactCountdownController);
app.register("react-minimal", ReactMinimalController);
app.register("react-generic", ReactGenericController);
